module.exports = __webpack_public_path__ + "img/pop_bg.cd4a0abe.png";